import { render } from "./CustomerMergeModal.vue?vue&type=template&id=0e81bb79&scoped=true"
import script from "./CustomerMergeModal.vue?vue&type=script&lang=js"
export * from "./CustomerMergeModal.vue?vue&type=script&lang=js"

import "./CustomerMergeModal.vue?vue&type=style&index=0&id=0e81bb79&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e81bb79"]])

export default __exports__